module.exports = __webpack_public_path__ + "img/hockey.91a5f88e.svg";